module.exports = __webpack_public_path__ + "static/media/SKHU_slogen_sk.3c2a7973.png";